import { render, staticRenderFns } from "./addNursingForm.vue?vue&type=template&id=0c62db96&scoped=true&"
import script from "./addNursingForm.vue?vue&type=script&lang=js&"
export * from "./addNursingForm.vue?vue&type=script&lang=js&"
import style0 from "./addNursingForm.vue?vue&type=style&index=0&id=0c62db96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62db96",
  null
  
)

export default component.exports